export const welcome = "כניסה למערכת";
export const enterDetails = "אנא הזינו מייל וסיסמא";
export const mailText = "מייל";
export const passwordText = "סיסמא";
export const enter = "כניסה";
export const user_not_exists = "משתמש או הסיסמא לא נמצאו. יש לפנות לאיש הקשר בעיון הפרשה שעמו סוכם על השותפות";
export const not_approved = "פרויקט השותפות עדיין לא אושר";
export const choose_text = "ברשותך יותר משותפות אחת פעילה, אנא בחר את השותפות הרצויה"
export const choose_button = "בחר שותפות"
export const return_choose = "לחזרה לבחירת שותפות"